module.exports = __webpack_public_path__ + "fonts/SuisseIntl-MediumItalic.759be22.woff";